<template>
  <div class="step status-type">
    <h5>Select status type</h5>
    <div
      class="row"
      style="margin-top: 118px;">
      <div
        v-for="(type, index) in types"
        :key="index"
        :class="type.class"
        class="col d-flex">
        <div
          class="type"
          @click="setType(type.type)">
          <div class="type-content d-flex justify-content-center align-items-center">
            <div class="image-block d-flex justify-content-center">
              <img
                :src="getImageUrl( type.img )"
                class="image">
            </div>
            <p class="text-center">{{ type.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";

export default {
  name: "StatusType",
  mixins: [profileMixin],
  data() {
    return {
      types: [
        {img: '/images/notes.png', type: 'General', name: 'GENERAL', class: 'justify-content-end'},
        {img: '/images/ruler.png', type: 'Length check', name: 'LENGTH CHECK', class: 'justify-content-start'}
      ]
    }
  },
  methods: {
    setType(type) {
      this.$emit('type', type);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/AddCurlStatus/steps/StatusType.vue